import { AutogenModelEdipartnerXcmpOrders, AutogenRowEdipartnerXcmpOrders } from "./autogen/AutogenModelEdipartnerXcmpOrders";

export class ModelEdipartnerXcmpOrders extends AutogenModelEdipartnerXcmpOrders<RowEdipartnerXcmpOrders> {
	constructor() {
		super(RowEdipartnerXcmpOrders);
	}
}

export class RowEdipartnerXcmpOrders extends AutogenRowEdipartnerXcmpOrders {
}